module.exports = __webpack_public_path__ + "img/04.92073c82.jpg";